import { render, staticRenderFns } from "./Welcome.vue?vue&type=template&id=7612b5a9&scoped=true"
import script from "./Welcome.vue?vue&type=script&lang=js"
export * from "./Welcome.vue?vue&type=script&lang=js"
import style0 from "./Welcome.vue?vue&type=style&index=0&id=7612b5a9&prod&scoped=true&lang=css"
import style1 from "./Welcome.vue?vue&type=style&index=1&id=7612b5a9&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7612b5a9",
  null
  
)

export default component.exports